import type { AssetType } from '#/graphql/types';
import type { FormItem } from '#/common/components/Form';
import allFields from '#/modules/asset/assetType/utils/fields';
import { inUseStatuses } from '../AssetType.Mappings';
import { getHistorySection } from '#/common/utils/fields/historySection';

export const createFields: FormItem<AssetType>[] = [
  {
    cssClass: 'tmm-section-no-background',
    caption: 'Asset Type Details',
    colCount: 2,
    items: [allFields.tenantId],
  },
  {
    cssClass: 'tmm-section tmm-section-no-caption',
    colCount: 2,
    items: [
      { ...allFields.name, colSpan: 1 },
      { ...allFields.category, colSpan: 1 },
      { ...allFields.criticalityLevel, colSpan: 1 },
      { ...allFields.defaultRiskScore, colSpan: 1 },
      { ...allFields.defaultWarrantyPeriod, colSpan: 1 },
      { ...allFields.expectedUsefulLife, colSpan: 1 },
      { ...allFields.description, colSpan: 2 },
      { ...allFields.manufacturerRecommendations, colSpan: 2 },
    ],
  },
];

export const updateFields: FormItem<AssetType>[] = [
  {
    cssClass: 'tmm-section-no-background',
    caption: 'Asset Type Details',
    colCount: 2,
    items: [allFields.tenantId],
  },
  {
    cssClass: 'tmm-section tmm-section-no-caption',
    colCount: 6,
    items: [
      { ...allFields.name, colSpan: 2 },
      { ...allFields.category, colSpan: 2 },
      { ...allFields.inUseStatus, colSpan: 2 },
      { ...allFields.criticalityLevel, colSpan: 3 },
      { ...allFields.defaultRiskScore, colSpan: 3 },
      { ...allFields.defaultWarrantyPeriod, colSpan: 3 },
      { ...allFields.expectedUsefulLife, colSpan: 3 },
      { ...allFields.description, colSpan: 6 },
      { ...allFields.manufacturerRecommendations, colSpan: 6 },
    ],
  },

  getHistorySection(),
];
